import axios from 'axios';
import { logNewRelicJSError } from '../../utils/logNewRelicCustom';
import { errorInteractions } from '../../analytics';

/**
 * Update project with cart status
 * @param {string} host - API host URL
 * @param {Object} projectData - Project data to update
 * @param {string} projectData.Id - Project ID
 * @param {string} [projectData.Name] - Project name
 * @param {string} [projectData.UserId] - User ID
 * @param {boolean} [projectData.IsCarted] - Cart status
 * @returns {Promise<Object>} Updated project response
 */
export const updateProject = async (host, projectData) => {
  const errorMsg = 'Update Project: Request failed';
  const apiUrl = `${host}/api/modulardesigner/project/updateProject`;

  try {
    const response = await axios.post(apiUrl, projectData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response?.status === 200) {
      return response.data;
    }
    throw new Error(errorMsg);
  } catch (err) {
    const errorPayload = {
      updateProjectError: {
        apiUrl,
        payLoad: projectData,
        message: err.message,
        stack: err.stack
      }
    };
    logNewRelicJSError(new Error(JSON.stringify(errorPayload)));
    throw new Error(errorMsg);
  }
};

export const getProject = async (host, id) => {
  const errorMsg = 'Get Project: Request failed';
  const apiUrl = `${host}/api/modulardesigner/project/${id}`;

  try {
    const response = await axios.get(apiUrl);

    if (response?.status === 200) {
      return response.data;
    }
    throw new Error(errorMsg);
  } catch (err) {

    const errorObject = {
      type: 'catastrophic',
      displayType: 'inline',
      pageSection: 'Get Project',
      message: errorMsg,
    };
    const trackErrorInteractions = { errorObject, primaryCategory: 'error', eventName: 'post page error' };
    errorInteractions(trackErrorInteractions);
    return null;
  }
};